<template>
  <div class="grid-spans-2 grid w-auto gap-1">
    <div class="grid-spans-3 grid w-auto gap-16 sm:hidden">
      <Skeleton
        type="custom"
        class="max-h-md group aspect-h-5 aspect-w-10 relative flex items-center justify-center bg-gray"
      />
      <Skeleton
        type="custom"
        class="max-h-md group aspect-h-2 aspect-w-10 relative flex items-center justify-center bg-gray"
      />
      <Skeleton
        type="custom"
        class="max-h-md group aspect-h-5 aspect-w-10 relative flex items-center justify-center bg-gray"
      />
    </div>
    <div class="hidden w-auto grid-cols-3 gap-1 sm:grid">
      <Skeleton
        type="custom"
        class="max-h-md group aspect-h-14 aspect-w-10 relative flex items-center justify-center bg-gray"
      />
      <Skeleton
        type="custom"
        class="max-h-md group aspect-h-14 aspect-w-10 relative flex items-center justify-center bg-gray"
      />
      <div class="grid-spans-3 grid w-auto gap-20">
        <Skeleton
          type="custom"
          class="max-h-md group aspect-h-1 aspect-w-10 relative mx-16 my-10 flex items-center justify-center bg-gray"
        />
        <div class="grid w-auto grid-cols-2 gap-1">
          <Skeleton
            type="custom"
            class="max-h-md group aspect-h-4 aspect-w-8 relative ml-16 flex items-center justify-center bg-gray"
          />
        </div>

        <Skeleton
          type="custom"
          class="max-h-md group aspect-h-1 aspect-w-10 relative mx-10 mb-16 mt-36 flex items-center justify-center bg-gray"
        />
      </div>
    </div>
    <div class="hidden w-auto grid-cols-3 gap-1 sm:grid">
      <Skeleton
        type="custom"
        class="max-h-md group aspect-h-14 aspect-w-10 relative flex items-center justify-center bg-gray"
      />
      <Skeleton
        type="custom"
        class="max-h-md group aspect-h-14 aspect-w-10 relative flex items-center justify-center bg-gray"
      />
    </div>
  </div>
</template>
